module.exports = __webpack_public_path__ + "img/china.d50da17f.png";